<!-- single-file components with a .vue extension -->
<template>
  <transition v-cloak name="modal">
    <v-modal :is-open="showModal" data-test="poa-modal" @close="showModal = false">
      <template #content>
        <h3 v-html="message" />
      </template>

      <template #footer>
        <div class="grid-x align-center">
          <button class="button cell small-4 align-center" @click="redirectToBrand()">
            {{ labelRedirect }}
          </button>
          <div class="cell small-1" />
          <button class="button cell small-4 align-center" @click="showModal = false">
            {{ labelNo }}
          </button>
        </div>
      </template>
    </v-modal>
  </transition>
</template>

<script>
export default {
  name: 'PoaModal',
  emits: ['reset'],
  props: {
    labelRedirect: {
      type: String,
      default: 'Ja'
    },
    labelNo: {
      type: String,
      default: 'Nej'
    },
    redirectMessages: {
      type: Object,
      default() {
        return {
          LB: '',
          Runa: '',
          Bauta: '',
          PFA: ''
        };
      }
    },
    redirectTo: {
      type: String,
      default: null
    },
    contactId: {
      type: [Number, String],
      default: null
    }
  },
  data() {
    return {
      showModal: false
    };
  },
  computed: {
    message() {
      if (this.redirectTo !== null) {
        return this.redirectMessages[this.redirectTo];
      }
    }
  },
  watch: {
    contactId(val) {
      if (val) {
        this.showModal = true;
      } else {
        this.showModal = false;
      }
    },
    showModal(val) {
      if (!val) {
        this.$emit('reset');
      }
    }
  },

  mounted() {},
  methods: {
    redirectToBrand() {
      if (this.contactId) {
        const brandUrl = {
          LB: 'lb',
          Bauta: 'bauta',
          Runa: 'runa',
          PFA: 'lbforsikring-pfa'
        };
        const urlArray = window.location.origin.split('.');
        urlArray[1] = brandUrl[this.redirectTo];
        const url = `${urlArray.join('.')}`;

        window.open(url, '_blank');
        this.showModal = false;
      }
    }
  }
};
</script>
